import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import buildPATHS from '../../utils/paths';

const UnauthorizedRedirect = (props: any) => {
  const history = useHistory();
  const PATHS = buildPATHS();
  useEffect(() => {
    history.push(PATHS.login);
  }, []);

  return null;
};

export default UnauthorizedRedirect;
